import React from "react";
import { cn } from "../lib/utils";
import { SALE_STATUS_LABELS, SALE_STATUS_TONE } from "../lib/constants";

const TONES = {
  success: "bg-emerald-50 text-emerald-700 border-emerald-200",
  warning: "bg-amber-50 text-amber-700 border-amber-200",
  danger: "bg-red-50 text-red-700 border-red-200",
  neutral: "bg-slate-100 text-slate-700 border-slate-200",
  info: "bg-blue-50 text-blue-700 border-blue-200",
};

export function Pill({ tone = "neutral", children, className, ...rest }) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-semibold",
        TONES[tone],
        className,
      )}
      {...rest}
    >
      <span className={cn("h-1.5 w-1.5 rounded-full", {
        "bg-emerald-500": tone === "success",
        "bg-amber-500": tone === "warning",
        "bg-red-500": tone === "danger",
        "bg-slate-400": tone === "neutral",
        "bg-blue-500": tone === "info",
      })} />
      {children}
    </span>
  );
}

export function SaleStatusPill({ status }) {
  return (
    <Pill tone={SALE_STATUS_TONE[status] || "neutral"} data-testid={`sale-status-${status}`}>
      {SALE_STATUS_LABELS[status] || status}
    </Pill>
  );
}

export function TaskStatusPill({ status }) {
  if (status === "completed") {
    return <Pill tone="success" data-testid={`task-status-${status}`}>Completed</Pill>;
  }
  if (status === "skipped") {
    return <Pill tone="neutral" data-testid={`task-status-${status}`}>Skipped</Pill>;
  }
  return <Pill tone="danger" data-testid={`task-status-${status}`}>Pending</Pill>;
}
